import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, deleteData, getAllData } from "../../Utility/API";
import { Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import { Delete } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import CreateSurvey from "./CreateSurvey";
import SurveyResultsModal from "./SurveyResultsModal";

// Dates arrive as ISO-8601 with the server's offset — render them in the viewer's
// timezone. Legacy rows with no offset fall back to showing the stored wall clock.
const fmtDate = (v) => {
  if (!v) return "-";
  const d = new Date(v);
  return isNaN(d.getTime()) ? String(v).replace("T", " ").slice(0, 16) : d.toLocaleString();
};

const rewardText = (row) => {
  if (!row.rewardType || row.rewardType === "NONE") return "None";
  return `${Number(row.rewardValue || 0)} ${row.rewardType}`;
};

const optionCount = (row) =>
  [row.option1, row.option2, row.option3, row.option4].filter((o) => o && o.trim()).length;

const Survey = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [resultsSurvey, setResultsSurvey] = useState(null);

  useEffect(() => {
    fetchSurveys();
  }, []);

  const fetchSurveys = async () => {
    setIsLoading(true);
    try {
      const response = await getAllData(`${endPoints.api.SURVEY_ALL}`);
      if (response?.status === "success") setRows(response.data || []);
      else ErrorToast("Failed to fetch surveys");
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteSurvey = (id) => {
    if (!window.confirm("Delete this survey? Its votes will be removed too.")) return;
    setIsLoading(true);
    deleteData(`${endPoints.api.SURVEY_DELETE}/${id}`)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.status === "success") {
          SuccesToast("Survey deleted");
          fetchSurveys();
        } else ErrorToast(response?.data?.message || "Failed to delete survey");
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const toggleActive = (row) => {
    const next = !row.active;
    addData(`${endPoints.api.SURVEY_ACTIVE}/${row.id}/${next}`, {})
      .then((response) => {
        if (response?.data?.status === "success") {
          SuccesToast(response?.data?.message || "Survey updated");
          fetchSurveys();
        } else ErrorToast(response?.data?.message || "Failed to update survey");
      })
      .catch((err) => console.error(err));
  };

  const onClose = () => {
    setShowForm(false);
    fetchSurveys();
  };

  return (
    <div className="main">
      <Toaster />
      {isLoading && <Loader spinner={true} visible={isLoading} />}
      <div id="Sportbook" style={{ padding: "0px" }}>
        <div className="container-fluid bg-color-sportbook custom-card4">
          <div className="inner-space1">
            <div className="row">
              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #444" }}
              >
                <h3 className="mb-2" style={{ fontFamily: "ArticulatCF-Bold" }}>Surveys</h3>
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <Button
                    variant="primary"
                    style={{ height: "fit-content", fontWeight: 600, padding: "8px 20px", borderRadius: 4, marginBottom: 12 }}
                    onClick={() => { setEditData({}); setShowForm(true); }}
                  >
                    Add Survey
                  </Button>
                </div>
              </div>
            </div>

            <CreateSurvey open={showForm} onClose={onClose} editData={editData} />
            <SurveyResultsModal survey={resultsSurvey} onClose={() => setResultsSurvey(null)} />

            <div className="container-fluid table-custom">
              <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                <div className="col-md-12">
                  <TableContainer component={Paper}>
                    <Table className="c_table" size="small" stickyHeader sx={{ minWidth: 500 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">Title</TableCell>
                          <TableCell align="center">Question</TableCell>
                          <TableCell align="center">Options</TableCell>
                          <TableCell align="center">Reward</TableCell>
                          <TableCell align="center">From</TableCell>
                          <TableCell align="center">Until</TableCell>
                          <TableCell align="center">Active</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row, i) => (
                          <TableRow key={row.id || i}>
                            <TableCell align="center">{row.title || "-"}</TableCell>
                            <TableCell align="center">{row.question || "-"}</TableCell>
                            <TableCell align="center">{optionCount(row)}</TableCell>
                            <TableCell align="center">{rewardText(row)}</TableCell>
                            <TableCell align="center">{fmtDate(row.startDate)}</TableCell>
                            <TableCell align="center">{fmtDate(row.endDate)}</TableCell>
                            <TableCell align="center">
                              <Switch size="small" checked={!!row.active} onChange={() => toggleActive(row)} />
                            </TableCell>
                            <TableCell align="center">
                              <div style={{ display: "flex", gap: 10, justifyContent: "center", alignItems: "center" }}>
                                <AiOutlineEdit
                                  size={20}
                                  title="Edit"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => { setEditData(row); setShowForm(true); }}
                                />
                                <span onClick={() => deleteSurvey(row.id)} title="Delete" style={{ cursor: "pointer" }}>
                                  <Delete />
                                </span>
                                <span
                                  onClick={() => setResultsSurvey(row)}
                                  title="Results"
                                  style={{ cursor: "pointer", fontSize: 12, textDecoration: "underline" }}
                                >
                                  Results
                                </span>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                        {!rows.length && (
                          <TableRow>
                            <TableCell colSpan={8} align="center">No surveys yet.</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Survey;
